import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import React, { RefObject, useMemo } from 'react'

const htmlContentStyle: SxProps = {
  '& > p': {
    marginBlockStart: 0,
  },
  '& > p:last-child': {
    marginBlockEnd: 0,
  },
}

type HtmlContentWithMentionsProps = {
  htmlContent: string
  sx?: SxProps
  textRef?: RefObject<HTMLSpanElement | null>
}

const HtmlContent: React.FC<HtmlContentWithMentionsProps> = ({ htmlContent, sx, textRef }) => {
  // React re-runs innerHTML whenever this object identity changes, which would
  // discard DOM nodes (and any attributes added to them) on every render.
  const innerHtml = useMemo(() => ({ __html: htmlContent }), [htmlContent])

  return (
    <Typography
      component="span"
      className="fr-view"
      ref={textRef}
      sx={{ ...htmlContentStyle, ...sx }}
      dangerouslySetInnerHTML={innerHtml}
    />
  )
}

export default HtmlContent
